<template>
	<div style="height: 84vh;">
		<!-- <div class="tenant_search">
			<div class="tenant_search_1">
				<i></i>
				<el-input placeholder="请输入优惠券" prefix-icon="el-icon-search" v-model="phone"></el-input>
			</div>
			<div class="tenant_search_1">
				<i></i>
				<el-input placeholder="请输入姓名或手机号" prefix-icon="el-icon-search" v-model="phone"></el-input>
			</div>
			<button class="search_button" @click="search()">搜索</button>
			<button class="search_button" @click="search('重置')">重置</button>
		</div> -->
		<ListingButton :lists="lists" @add='add' @disable='disable' @recovery='recovery' @delete='BatchDelete'>
		</ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@SwitchStatus="SwitchStatus" style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
	</div>
</template>
<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		coupon_list,
		coupon_hard_delete,
		coupon_switch
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'coupon',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '禁用',
					type: 'warning',
					icon: 'el-icon-remove-outline',
					funt: 'disable'
				}, {
					name: '恢复',
					type: 'success',
					icon: 'el-icon-refresh-right',
					funt: 'recovery'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'delete'
				}, ],
				tableData: [],
				table_label: [{
					label: ' ID',
					value: 'id'
				}, {
					label: '优惠券名称',
					value: 'name'
				}, {
					label: '用户名',
					value: 'user_name'
				}, {
					label: '添加时间',
					value: 'create_time'
				}, {
					label: '是否使用',
					value: 'is_use'
				}, {
					label: '状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15
				},
				phone: ''
			}
		},
		methods: {
			search(resetting) {

				if (resetting != undefined) {
					this.room_number = ''
					this.tenant = ''
					this.name = ''
					this.phone = ''
				}
			},
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				coupon_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加优惠券'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '优惠券编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				coupon_hard_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				coupon_hard_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			// 状态更改
			SwitchStatus(value) {
				const {
					id,
					status
				} = value
				console.log('id:', id, 'status', status);
				coupon_switch({
					ids: [`${id}`],
					status: `${status}`
				}).then(res => {
					this.Messages(res)
					if (res.status != 200) {
						couponspecies_list(this.data).then(res => {
							console.log('res', res);
							if (res.status == 200) {
								this.tableData = res.data.list
								this.total = res.data.count
							}
						})
					}
				})
			},
			//批量禁用
			disable() {
				coupon_switch({
					ids: this.multipleSelection,
					status: '0'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			//批量启用
			recovery() {
				coupon_switch({
					ids: this.multipleSelection,
					status: '1'
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: #fff;
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 3.5rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 2.8rem;
	}


	.tenant_search_1 .el-input {
		width: 9rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>